import "./style.css"

function Input({ label, field, form, setForm, alertCss, ex, pw }) {
    return (
        <div className="inp_field">
            <label>{label} <span className="red">*</span></label>
            <input
                type={pw ? 'password' : 'text'}
                placeholder={`Entrez votre ${pw ? 'mot de passe' : 'réponse'}`}

                value={form[field]}
                onChange={(e) => setForm({
                    ...form,
                    [field]: e.target.value
                })}
            />

            {ex && <span className="exemple">{ex}</span>}
            <span className={`alert ${alertCss[field] ? 'alertActif' : ''}`}>Ce champ est obligatoire</span>
        </div>
    )
}

export default Input;